import { ListboxDesignTokens } from '@primeuix/themes/types/listbox';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { t, tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/listbox/index.ts
const lb = componentCommon.listbox;
const lbCs = componentColorScheme.listbox;
const lbDeep = tDeep(lb);

export const ListboxTelekomDT: ListboxDesignTokens = {
  root: {
    background: t(lb.background),
    disabledBackground: t(lb.disabled.background),
    borderColor: t(lb.border.color),
    invalidBorderColor: t(lb.invalid.border.color),
    color: t(lb.color),
    disabledColor: t(lb.disabled.color),
    borderRadius: t(lb.border.radius),
  },
  list: {
    padding: `${lbDeep.list.padding.y} ${lbDeep.list.padding.x}`,
    gap: t(lb.list.gap),
    header: {
      padding: `${lbDeep.list.header.padding.top} ${lbDeep.list.header.padding.right} ${lbDeep.list.header.padding.bottom} ${lbDeep.list.header.padding.left}`,
    },
  },
  option: {
    focusBackground: t(lb.option.focus.background),
    selectedBackground: t(lb.option.selected.background),
    selectedFocusBackground: t(lb.option.selected.focus.background),
    color: t(lb.option.color),
    focusColor: t(lb.option.focus.color),
    selectedColor: t(lb.option.selected.color),
    selectedFocusColor: t(lb.option.selected.focus.color),
    padding: `${lbDeep.option.padding.y} ${lbDeep.option.padding.x}`,
    borderRadius: t(lb.option.border.radius),
    stripedBackground: t(lbCs.option.striped.background),
  },
  optionGroup: {
    background: t(lb.option.group.background),
    color: t(lb.option.group.color),
    padding: `${lbDeep.option.group.padding.y} ${lbDeep.option.group.padding.x}`,
  },
  checkmark: {
    color: t(lb.checkmark.color),
    gutterStart: t(lb.checkmark.gutter.start),
    gutterEnd: t(lb.checkmark.gutter.end),
  },
};
